import { RouterProvider, createBrowserRouter, redirect } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage/HomePage';
import LoginPage from './pages/LoginPage/LoginPage';
import { jwtDecode } from "jwt-decode";
import UserProfileService from './services/UserProfileService';
import { useDispatch } from 'react-redux';
import { login } from './store/features/authSlice';
import PaymentCallback from './pages/PaymentCallback';

const App = () => {
	const dispatch = useDispatch();

	// Check user already logged in
	const isValidToken = (token: string | null) => {
		if(token)
		{
			// Expired token
			const decodedToken = jwtDecode(token);
			if(Date.now() > decodedToken.exp! * 1000)
			{
				console.log("❌ Token expired");
				return false;
			}
			// Valid token
			else
			{
				console.log("✅ User already logged in");
				return true;
			}
		}
		
		return false;
	};

	const routeAuthGuard = async () => {
		const token = localStorage.getItem("token");

		if(!isValidToken(token))
		{
			localStorage.removeItem("token");
			return redirect("/login");
		}

		// if(!store.getState().auth.token)
		// 	return redirect("/login");

		// Load user Profile
		let up = await UserProfileService.getUserProfile(token!);
		dispatch(login({ ...up, token: token!, expiration: jwtDecode(token!).exp! * 1000 }));

		return null;
	};

	const router = createBrowserRouter([
		{
			path: "/",
			element: <HomePage />,
			loader: routeAuthGuard
		},
		{
			path: "/login",
			element: <LoginPage />
		},
		{
			path: "/payment-callback",
			element: <PaymentCallback />,
			loader: routeAuthGuard
		}
	]);

	return (
		<RouterProvider router={ router } />
	);
}

export default App;